import * as React from "react";
import { Icon } from "@fluentui/react";

const styles = require("./CrossLocationIcon.scss");

export default function CrossLocationIcon({ showConflictIcon }: { showConflictIcon: boolean }): JSX.Element {
    if (showConflictIcon) {
        return <Icon className={styles.crossLocationIconWithConflictIcon} iconName="cross-location" />;
    }
    return <Icon className={styles.crossLocationIcon} iconName="cross-location" />;
}
